export default __webpack_public_path__ + "static/media/cancelIcon.5242d6c6.svg";